import { orderBody } from './format.js';

// URL state and command intent are independent from React for validation.
export const PAGE_SIZE = 20;

export function positiveId(value) {
    if (value == null || !/^\d+$/.test(String(value))) return null;
    const id = Number(value);
    return Number.isSafeInteger(id) && id > 0 ? id : null;
}

export function pageOffset(value) {
    return positiveId(value) ?? 0;
}

export function durationFilters(projectId, repositoryId) {
    const project = positiveId(projectId);
    const repository = positiveId(repositoryId);
    return {
        ...(project && { project_id: project }),
        ...(repository && { repository_id: repository }),
    };
}

export function orderRetryable(error) {
    return !!error && (error.isNetwork || error.isTimeout || error.status >= 500);
}

export function orderIntent(previous, { verb, row, taskId, reason, now }) {
    if (previous) return previous;
    const taskOrder = verb === 'interrumpir' || verb === 'reintentar';
    return orderBody({
        verb,
        seatRevision: row.seat.revision,
        controlRevision: row.control?.revision,
        taskId: taskOrder ? (taskId ?? row.work?.task?.id) : undefined,
        attemptId: taskOrder ? row.work?.attempt?.id : undefined,
        reason: reason?.trim() || undefined,
        now,
    });
}

export const ORDER_ACTIONS = {
    habilitar: {
        key: 'habilitar',
        label: 'Permitir nuevas tareas',
        permission: 'machines:admin',
        also: ['tokens:admin'],
        does: 'Permite que este puesto reciba nuevas tareas autorizadas en su alcance.',
    },
    pausar_tomas: {
        key: 'pausar_tomas',
        label: 'Pausar nuevas tareas',
        permission: 'machines:admin',
        does: 'Deja de asignar trabajo nuevo a este puesto. La tarea que esté ejecutando puede continuar.',
    },
    interrumpir: {
        key: 'interrumpir',
        label: 'Solicitar interrupción',
        permission: 'machines:admin',
        does: 'Solicita al equipo que detenga la ejecución actual. Espera su confirmación antes de darla por detenida.',
    },
    reintentar: {
        key: 'reintentar',
        label: 'Solicitar reintento',
        permission: 'machines:admin',
        does: 'Solicita un nuevo intento al equipo. Mastermind volverá a comprobar el estado y los permisos de la tarea.',
    },
};
